import { jsx as t } from "react/jsx-runtime";
import { tv as a } from "tailwind-variants";
const o = a({
  base: ["bg-neutral-200", "border-none", "h-[1px]", "min-h-[1px]", "w-full"]
}), m = ({ className: s, tagName: e = "hr" }) => /* @__PURE__ */ t(e, { className: o({ class: s }) });
export {
  m as default
};
